import cn from 'classnames';
import React from 'react';

import { FlipText } from '../FlipText';
import { Icon } from '../Icon';
import * as Styled from './Button.styles';

const Button = ({ icon, variant = 'primary', children, ...props }) => {
  return (
    <Styled.Button
      {...props}
      variant={variant}
      className={cn(variant === 'primary' && 'glass-border')}
    >
      <FlipText text={children}>{icon && <Icon variant={icon} />}</FlipText>
    </Styled.Button>
  );
};

export default Button;
